import { FC, useEffect } from "react";
import {
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardSubtitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonMenuToggle,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { menu } from "ionicons/icons";
import { usePictures } from "../../Pictures/usePictures";
import { useCategories } from "../../Pictures/useCategories";
import { InfoEdit } from "./InfoEdit";
import { ADDITIONAL_EQUIPMENT_CATEGORY } from "../../../common/constants";

const Info: FC = () => {
  const { allPicturesAdmin, getAllPicturesAdmin } = usePictures();
  const { loadCategoriesAdmin } = useCategories();

  useEffect(() => {
    if (allPicturesAdmin.length === 0) getAllPicturesAdmin();
    loadCategoriesAdmin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allPicturesFiltered = allPicturesAdmin.filter(
    (p) => p.category !== ADDITIONAL_EQUIPMENT_CATEGORY
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="warning">
          <IonButtons slot="start">
            <IonMenuToggle>
              <IonIcon icon={menu} style={{ fontSize: 28 }} />
            </IonMenuToggle>
          </IonButtons>
          <IonTitle>Info</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonGrid>
          <IonRow>
            {allPicturesFiltered
              .sort((a, b) => (a.code > b.code ? 1 : -1))
              .map((pic) => (
                <IonCol key={pic.id} sizeXs="12" sizeSm="6" sizeMd="4">
                  <IonCard style={{ margin: 0 }}>
                    <img
                      src={`assets/pics/320/${pic.code}.jpg`}
                      alt={pic.fileName}
                      style={{
                        display: "block",
                        margin: "0 auto",
                        maxHeight: 200,
                        width: "auto",
                        opacity: pic.isDeleted ? 0.2 : 1,
                      }}
                    />
                    <IonCardContent style={{ padding: 3 }}>
                      <IonCardSubtitle
                        style={{ fontSize: 12, textAlign: "center" }}
                      >
                        <IonLabel>{pic.code}</IonLabel>
                        {!!pic.codeSP && (
                          <IonLabel
                            style={{
                              color: "var(--ion-color-medium)",
                              marginLeft: 5,
                            }}
                          >
                            {pic.codeSP}
                          </IonLabel>
                        )}
                      </IonCardSubtitle>
                    </IonCardContent>
                    <InfoEdit pic={pic} />
                  </IonCard>
                </IonCol>
              ))}
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Info;
